import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Plus, Trash2, Pencil } from "lucide-react";
import { toast } from "sonner";

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", icon: "", sort_order: 0, is_visible: true });

  const load = () => api.get("/admin/categories").then((r) => setCats(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (form.id) await api.patch(`/admin/categories/${form.id}`, form); else await api.post("/admin/categories", form);
      toast.success("Saved"); setOpen(false); setForm({ name: "", icon: "", sort_order: 0, is_visible: true }); load();
    } catch { toast.error("Failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/categories/${id}`); load(); };

  return (
    <div>
      <header className="mb-6 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-gray-400">Catalog</div>
          <h1 className="font-display text-2xl font-bold tracking-tight mt-1">Categories</h1>
        </div>
        <Button data-testid="cat-add-btn" onClick={() => setOpen(true)} className="rounded-lg bg-[var(--qd-charcoal)] hover:bg-black"><Plus className="w-4 h-4 mr-1" /> New</Button>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {cats.map((c) => (
          <div key={c.id} data-testid={`cat-card-${c.id}`} className="qd-admin-card p-4 flex items-center justify-between">
            <div>
              <div className="text-lg">{c.icon} <span className="font-semibold">{c.name}</span></div>
              <div className="text-xs text-gray-400">Order: {c.sort_order} · {c.is_visible ? "Visible" : "Hidden"}</div>
            </div>
            <div>
              <button data-testid={`cat-edit-${c.id}`} onClick={() => { setForm(c); setOpen(true); }} className="p-1.5 text-gray-500 hover:text-gray-800"><Pencil className="w-4 h-4" /></button>
              <button data-testid={`cat-delete-${c.id}`} onClick={() => del(c.id)} className="p-1.5 text-gray-500 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent><DialogHeader><DialogTitle>{form.id ? "Edit" : "New"} Category</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <Input data-testid="cat-name" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <Input data-testid="cat-icon" placeholder="Icon (emoji)" value={form.icon || ""} onChange={(e) => setForm({ ...form, icon: e.target.value })} />
            <Input data-testid="cat-order" type="number" placeholder="Sort order" value={form.sort_order} onChange={(e) => setForm({ ...form, sort_order: parseInt(e.target.value || "0") })} />
            <Button data-testid="cat-save" onClick={save} className="w-full bg-[var(--qd-charcoal)] hover:bg-black">Save</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
